module.exports = __webpack_public_path__ + "img/icon-1-1.f110327b.png";